/**
 * common tcc 文件暂时留着，之后可能还会用到
 */

import * as types from 'src/store/types';
import { getCommonTcc } from 'src/service/index';
import { getDefaultCommonTcc } from 'src/const/commonTcc';

export default {
  namespaced: true,
  state: {
    commonTcc: getDefaultCommonTcc(),
  },
  mutations: {
    [types.SET_COMMON_TCC](state, data) {
      if (!data) return;
      state.commonTcc = { ...state.commonTcc, ...data };
    },
  },
  getters: {
  },
  actions: {
    async fetchCommonTcc({
      commit,
    }, key) {
      const { data } = await getCommonTcc({
        tcc_key: key,
      });
      commit(types.SET_COMMON_TCC, data?.tcc_config);
    },
  },
};
